import { Component, OnInit,ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ServerService } from '../service/server.service';
import { ToastController,NavController,Platform,LoadingController,AlertController } from '@ionic/angular';
import {Constant} from "../shared/model/Constant";

@Component({
  selector: 'app-client',
  templateUrl: './client.page.html',
  styleUrls: ['./client.page.scss'],
})

export class ClientPage implements OnInit {
@ViewChild('input', {static: false}) searchInput: { setFocus: () => void; } ;
@ViewChild('content',{static : false}) private content: any;


  name:any;
  email:any;
  phone:any;
  address:any;
  vat:any;
  client_id:any;
  data:any;
  type:any = 0;
  logo:any;
  url:any;
  text:any;

  constructor(public alertController: AlertController,private route: ActivatedRoute,public server : ServerService,public toastController: ToastController,private nav: NavController,public loadingController: LoadingController){

   this.type  = this.route.snapshot.paramMap.get('type');
   this.text  = JSON.parse(localStorage.getItem(Constant.appText));

   if(localStorage.getItem(Constant.logo) && localStorage.getItem(Constant.logo) != 'null')
    {
      this.logo = localStorage.getItem(Constant.logo);
      this.url  = localStorage.getItem(Constant.url);
    }

  }

  ngOnInit()
  {
  }

  ionViewDidEnter()
  {
    this.loadData();
  }

  sc()
  {
    setTimeout(() => {
      this.content.scrollToBottom(300);
      }, 100);
  }

  async presentToast(txt) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 3000,
      position : 'top',
      mode:'ios',
      color:'dark'
    });
    toast.present();
  }


  async loadData()
  {
    const loading = await this.loadingController.create({
      message: '',
      spinner : 'bubbles',
      duration:3000
    });
    await loading.present();

    this.server.getClient().subscribe((response:any) => {

    this.data = response.data;

    localStorage.setItem(Constant.userData, JSON.stringify(response.user));
    localStorage.setItem(Constant.invoiceNo, response.invoice_no);



    loading.dismiss();

    });
  }

  conti()
  {

    if(this.client_id)
    {
      for(var i =0;i<this.data.length;i++)
      {
        if(this.client_id == this.data[i].id)
        {
          var client_data = this.data[i];
        }
      }
    }
    else
    {
      if(this.email)
      {
        if(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email))
        {
          var client_data:any = {name : this.name,email : this.email, phone : this.phone, address : this.address, vat : this.vat}
        }
        else
        {
          this.presentToast(this.text.valid_email);
          return this.searchInput.setFocus();

        }
      }
      else
      {
        var client_data:any = {name : this.name,email : this.email, phone : this.phone, address : this.address, vat : this.vat}
      }
    }

    localStorage.setItem(Constant.clientData, JSON.stringify(client_data));

    this.nav.navigateForward('/preview/'+this.type);
  }

  goBack()
  {
    this.nav.navigateBack('/invoice/'+this.type);
  }
}
